export default "__VITE_ASSET__C9GJnn3t__"